export default "__VITE_ASSET__709d8dd0__"